import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=01b7e10a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b7e10a')) {
      api.createRecord('01b7e10a', component.options)
    } else {
      api.reload('01b7e10a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=01b7e10a&", function () {
      api.rerender('01b7e10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gcyHCnXoqAH3/JS/comp/ImgFallback.vue"
export default component.exports